import { atom } from "recoil";
import { recoilPersist } from "recoil-persist";

const { persistAtom } = recoilPersist();

export const userState = atom({
	key: "currentUserState",
	default: null,
	effects_UNSTABLE: [persistAtom],
});


export const OrderDetailState = atom({
	key: "ordersDetail",
	default: null,
	effects_UNSTABLE: [persistAtom],
});
